module["exports"] = [
  "#####"
];


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/address/postcode.js
// module id = 1010
// module chunks = 0